import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

const EntityManager = lazy(() => import('@/pages/EntityManager'))

export const Route = createFileRoute('/_authenticated/data-management')({
  component: () => (
    <Suspense fallback={<DataManagementSkeleton />}>
      <EntityManager />
    </Suspense>
  ),
})

function DataManagementSkeleton() {
  return (
    <div className="flex h-full animate-pulse">
      <div className="w-56 shrink-0 border-r border-border/50 pr-4 mr-6 space-y-2">
        <div className="h-8 w-40 bg-muted rounded mb-4" />
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="h-9 bg-muted rounded-lg" />
        ))}
      </div>
      <div className="flex-1 space-y-4">
        <div className="h-8 w-48 bg-muted rounded" />
        <div className="h-4 w-72 bg-muted rounded" />
        <div className="h-9 bg-muted rounded" />
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="h-12 bg-muted rounded-xl" />
        ))}
      </div>
    </div>
  )
}
